import { render, staticRenderFns } from "./veHqChurukuShow.vue?vue&type=template&id=4abd80b7&scoped=true"
import script from "./veHqChurukuShow.vue?vue&type=script&lang=js"
export * from "./veHqChurukuShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abd80b7",
  null
  
)

export default component.exports